<ng-container *ngIf="field?.component === SubTabTableComponent">
    <app-sub-tab-table
 [formCtrl]="field.formCtrl"></app-sub-tab-table>
</ng-container>